import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import { userEmailHydrator } from '../../fieldOptions/hydrators'
import { roleName } from '../../fieldOptions/groupUserRoles'

const columns = [
  { title: 'Group', prop: 'group_id', references: 'admin/groups', referenceProp: 'name' },
  { title: 'User', prop: 'user_id', references: 'admin/users', referenceProp: 'name' },
  { title: 'Role', prop: 'coach_role', format: roleName },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  {
    name: 'Filter by group',
    prop: 'filters.group_id',
    type: 'autocomplete',
    references: 'admin/groups',
    referenceProp: 'name',
    enabled: true,
    query: {
      order: [{
        column: 'name_length',
        direction: 'asc'
      }]
    }
  },
  {
    name: 'Filter by user',
    prop: 'filters.user_id',
    type: 'autocomplete',
    displayProp: 'displayVal',
    dataHydrator: userEmailHydrator,
    references: 'admin/users',
    referenceProp: 'name',
    enabled: true
  },
  { name: 'Coaches only', prop: 'filters.is_coach', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [{ column: 'updated_at', direction: 'desc' }]
}
const Members = (props) => (
  <List
    title='Group Members'
    apiPath='admin/group_users'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default Members
